import type {Components, Theme} from '@mui/material/styles';

export const MuiLinearProgress = (theme: Theme): Components['MuiLinearProgress'] => ({
  defaultProps: {
    color: 'secondary',
  },
  styleOverrides: {
    root: {
      backgroundColor: theme.palette.bg3,
    },
  },
});
